/* src/app/private/components/view/roles/delete-role/delete-role.component.scss */
/*# sourceMappingURL=delete-role.component.css.map */
